<router-outlet>
    <app-loader-navigation></app-loader-navigation>
</router-outlet>
<app-loader></app-loader>
